/* eslint-disable no-empty, @typescript-eslint/no-this-alias, unicorn/no-this-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */

// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
if (window.Element && !window.Element.prototype.closest) {
  window.Element.prototype.closest = function closest (s: string): Element | null {
    // @ts-expect-error this.document -re hibát dobna.
    const matches = (this.document ?? this.ownerDocument).querySelectorAll(s)
    let i
    let el = this

    do {
      i = matches.length

      while (--i >= 0 && matches.item(i) !== el) {}
    }
    // @ts-expect-error az értékadás hibát dobna.
    while ((i < 0) && (el = el.parentElement))

    return el
  }
}
